// extracted by mini-css-extract-plugin
module.exports = {"bookShelf":"BookShelf_bookShelf__gEWR2","book":"BookShelf_book___uWsR","title":"BookShelf_title__YaZag","authors":"BookShelf_authors__4V56G","fade_in":"BookShelf_fade_in__t5Mzz"};